import BaseAPI from '@/apis/base/baseApi';

export default class AuthApi extends BaseAPI {
  apiName = 'Auth';
  constructor() {
    super();
  }
}
